import axios from 'axios';
import config from '../../../config';

const baseUrl = config.baseUrl;
const Endpoint = '/api/ultima-visita';

// Crear una instancia de Axios para configurar base URL y otras opciones
const api = axios.create({
    baseURL: config.baseUrl,
});


const getUltimaVisitaTecnica = async (id_participante) => {
    try {
        const response = await api.get(`${baseUrl}${Endpoint}/${id_participante}`);
        return {
            success: response.data.success,
            ultima_visita: response.data.ultima_visita,

        };
    } catch (error) {
        console.error('Error fetching ultima visita tecnica', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching ultima visita tecnica'
        };
    }
};

export default getUltimaVisitaTecnica;